import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useRef } from "react";
import ModuleHeader from "../components/ModuleHeader";
import ReactEcharts from "echarts-for-react";
import * as echarts from "echarts";
import { REM_CONFIG } from "@/utils/fontSize";
import { mmsApi } from "@/api/mmsApi";
const InboundOutboundStatus = ({ className = "", }) => {
    const [selectedTime, setSelectedTime] = useState("2025-09");
    const [chartData, setChartData] = useState([]);
    const chartRef = useRef(null);
    const timerRef = useRef(null);
    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await mmsApi.getInventoryCategory();
                const list = res.data || [];
                const formattedData = list.map((item) => ({
                    category: item.mname,
                    inbound: item.inboundQty,
                    outbound: item.outboundQty,
                }));
                setChartData(formattedData);
            }
            catch (err) {
                console.error("获取失败：", err);
            }
        };
        fetchData();
    }, []);
    const updateChartData = (time) => {
        const month = parseInt(time.split("-")[1], 10);
        const randomFactor = month * 0.1;
        setChartData((prev) => prev.map((item) => ({
            ...item,
            inbound: Math.floor(item.inbound + Math.random() * 50 * randomFactor),
            outbound: Math.floor(item.outbound + Math.random() * 40 * randomFactor),
        })));
    };
    const getChartOption = () => ({
        title: { show: false },
        legend: {
            data: ["入库", "出库"],
            right: "center",
            top: 5,
            textStyle: { color: "#fff", fontSize: REM_CONFIG.fontSize.small },
            itemGap: 30,
            itemWidth: 16,
            itemHeight: 8,
            icon: "rect",
        },
        tooltip: {
            trigger: "axis",
            axisPointer: { type: "shadow" },
            backgroundColor: "rgba(7, 31, 75, 0.8)",
            borderColor: "#446b9f",
            textStyle: { color: "#fff" },
        },
        grid: {
            left: 20,
            right: 40,
            bottom: 10,
            top: 40,
            containLabel: true,
        },
        yAxis: {
            type: "category",
            data: chartData.map((item) => item.category),
            axisLabel: {
                color: "#fff",
                fontSize: REM_CONFIG.fontSize.small,
                formatter: (value) => {
                    if (value.length > 4) {
                        return value.substring(0, 4) + "...";
                    }
                    return value;
                },
            },
            axisLine: { lineStyle: { color: "rgba(255,255,255,0.2)" } },
        },
        xAxis: {
            show: false,
            type: "value",
            name: "数量（项）",
            nameTextStyle: {
                color: "#fff",
                fontSize: REM_CONFIG.fontSize.small,
                padding: [30, 0, 0, 0],
            },
            axisLabel: { color: "#fff", fontSize: REM_CONFIG.fontSize.small },
            axisLine: { lineStyle: { color: "rgba(255,255,255,0.2)" } },
            splitLine: { show: true, lineStyle: { color: "rgba(255,255,255,0.1)" } },
        },
        graphic: {
            type: "text",
            right: 10,
            top: 10,
            style: {
                text: "单位：项",
                fill: "#fff",
                fontSize: REM_CONFIG.fontSize.small,
                fontFamily: "Arial, sans-serif",
            },
        },
        // ==========================
        // ✅ 已修正：43 → 10
        // ==========================
        dataZoom: [
            {
                type: "inside",
                yAxisIndex: 0,
                start: 0,
                end: 10,
                scrollSensitivity: 10,
            },
        ],
        series: [
            {
                name: "入库",
                type: "bar",
                data: chartData.map((item) => item.inbound),
                itemStyle: {
                    color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                        { offset: 0, color: "#2F96E2" },
                        { offset: 1, color: "#1572C4" },
                    ]),
                    barBorderRadius: [0, 8, 8, 0],
                },
                barWidth: "30%",
                barGap: "20%",
                label: {
                    show: true,
                    position: "right",
                    color: "#fff",
                    fontSize: REM_CONFIG.fontSize.small,
                    formatter: "{c}",
                },
            },
            {
                name: "出库",
                type: "bar",
                data: chartData.map((item) => item.outbound),
                itemStyle: {
                    color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                        { offset: 0, color: "#60FFFF" },
                        { offset: 1, color: "#40C0FF" },
                    ]),
                    barBorderRadius: [0, 8, 8, 0],
                },
                barWidth: "30%",
                barGap: "20%",
                label: {
                    show: true,
                    position: "right",
                    color: "#fff",
                    fontSize: REM_CONFIG.fontSize.small,
                    formatter: "{c}",
                },
            },
        ],
    });
    useEffect(() => {
        updateChartData(selectedTime);
        const handleResize = () => {
            chartRef.current?.getEchartsInstance()?.setOption(getChartOption());
        };
        window.addEventListener("resize", handleResize);
        timerRef.current = setInterval(() => {
            const chartInstance = chartRef.current?.getEchartsInstance();
            if (chartInstance) {
                const option = chartInstance.getOption();
                if (Array.isArray(option.dataZoom) && option.dataZoom.length > 0) {
                    const dataZoomOpt = option
                        .dataZoom[0];
                    const newStart = (dataZoomOpt.start || 0) + 0.5;
                    chartInstance.setOption({
                        // ==========================
                        // ✅ 已修正：43 → 10
                        // ==========================
                        dataZoom: [{ ...dataZoomOpt, start: newStart, end: newStart + 10 }],
                    });
                }
            }
        }, 300);
        return () => {
            window.removeEventListener("resize", handleResize);
            timerRef.current && clearInterval(timerRef.current);
        };
    }, [selectedTime]);
    return (_jsxs("div", { className: `
        relative bg-gradient-to-tr from-[#071F4A] to-[#0f295300]
        flex flex-col ${className}
      `, children: [_jsx(ModuleHeader, { title: "\u5E93\u5B58\u7C7B\u522B\u5206\u5E03" }), _jsx("div", { className: "flex-1", style: { minHeight: 0 }, children: _jsx(ReactEcharts, { ref: chartRef, option: getChartOption(), style: { width: "100%", height: "100%" }, echarts: echarts }) })] }));
};
export default InboundOutboundStatus;
